export default {
  tracked: false,
  dispositionRequest: null,
  returnPath: null,
  nextReceipt: null,
  reset() {
    this.tracked = false;
    this.dispositionRequest = null;
    this.returnPath = null;
    this.nextReceipt = null;
  },
};
